import { useStore } from 'react-context-hook'
import { VscChecklist } from "react-icons/vsc"
import I18n from '/src/utils/translations'
import useRequestConfirmationPopup from '/src/ui/domain/requests/request_confirmation_popup'
import PropTypes from 'prop-types'
import React from 'react'

export default function BatchConfirmIcon({ showConfirmation, dataItem }) {
  const showActionConfirmation = useRequestConfirmationPopup(showConfirmation)
  const successBtnColor = '#607D8B'
    const [_,setSelectedIds] = useStore('selected_items') 

  const dataItem_ids = dataItem.map(item => item.id)
  const setBatchConfirm = () => {

    const actionParams = (opts) => {
      return {
        resourcePath: 'requests',
        requestAction: 'UPDATE',
        httpAction: 'put',
        additionalResource: { path: opts.path },
        data: {requests_ids: opts.ids}
      }
    }
    
    showActionConfirmation(
      dataItem,
      actionParams({ ids: dataItem_ids, path: 'batch_realize' }),
      {
        actionName: 'confirm',
        buttonColor: successBtnColor,
        actionText: I18n.t('requests.confirmation_modal.confirm_confirmation'),
        cancelText: I18n.t('requests.confirmation_modal.confirm_cancel'),
        batch: true
      }
    ),
    setSelectedIds([]);
  }

  return (
    <div className="popup-icon">
      <VscChecklist
        className={`open-icon-popup`}
        style={{ fontSize: "1.6rem", cursor: "pointer" }}
        key='batch-confirm-icon'
        onClick={setBatchConfirm}
        title={I18n.t('actions.batch_confirm')}
      />
    </div>
  )
}

BatchConfirmIcon.PropTypes = {
    showConfirmation: PropTypes.func,
    dataItem: PropTypes.oneOfType([PropTypes.array])
}

BatchConfirmIcon.defaultProps = {
    showConfirmation: () => {},
    dataItem: null
}